import { render, staticRenderFns } from "./mathOptions.vue?vue&type=template&id=c838f4ca&lang=pug&"
import script from "./mathOptions.vue?vue&type=script&lang=js&"
export * from "./mathOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports